import React from 'react';

const ControlIcon = ({ handler, Icon }) => {
  return (
    <div className="flex items-center justify-end">
      <div
        onClick={handler}
        className="flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full p-2"
        style={{ width: 'fit-content' }}
        id="icon-chart">
        <Icon className="text-orange-500 w-6 sm:w-6 xl:w-8 2xl:w-8 h-6 sm:h-6 xl:h-7 2xl:h-7" />
      </div>
    </div>
  );
};
export default ControlIcon;
